import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Hero } from "@/components/home/Hero";
import { CategoriesGrid, SectionHead } from "@/components/home/CategoriesGrid";
import { Comparison } from "@/components/home/Comparison";
import { OperationModels } from "@/components/home/OperationModels";
import { EsgSection } from "@/components/home/EsgSection";
import { ImpactCalculator } from "@/components/ImpactCalculator";
import { LotCard } from "@/components/LotCard";
import { API } from "@/lib/api";

const LatestLots = () => {
  const [lots, setLots] = useState([]);
  useEffect(() => {
    axios.get(`${API}/lots`).then((r) => setLots(r.data.slice(0, 4))).catch(() => setLots([]));
  }, []);
  if (!lots.length) return null;
  return (
    <section className="max-w-[1400px] mx-auto px-5 lg:px-8 pb-24" data-testid="latest-lots-section">
      <div className="flex items-end justify-between gap-4">
        <SectionHead eyebrow="Marketplace" title="Lotes disponibles ahora" />
        <Link to="/marketplace" className="mb-12 text-sm font-semibold text-[#00915f] hover:underline whitespace-nowrap" data-testid="latest-lots-view-all">Ver todos →</Link>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {lots.map((l, i) => <LotCard key={l.id} lot={l} index={i} />)}
      </div>
    </section>
  );
};

export default function Home() {
  return (
    <main>
      <Hero />
      <CategoriesGrid />
      <LatestLots />
      <Comparison />
      <OperationModels />
      <EsgSection />
      <section className="max-w-[1400px] mx-auto px-5 lg:px-8 py-24" id="calculadora">
        <SectionHead eyebrow="Calculadora rápida" title="¿Cuánto vale tu merma y cuánto CO₂ evita?" />
        <ImpactCalculator />
      </section>
    </main>
  );
}
